








































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Action, Getter } from "vuex-class"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faCheck } from "@fortawesome/free-solid-svg-icons"

import AnimatedProgressBar from "@/components/AnimatedProgressBar.vue"
import TaskBadge from "@/components/Gamification/TaskBadge.vue"
import Typography from "@/components/Rain/Typography/Typography.vue"
import { AchievementDetails, AchievementBadges } from "@/entities/tasks"

@Component<TaskCard>({
    components: {
        TaskBadge,
        Typography,
        AnimatedProgressBar,
        FontAwesomeIcon
    }
})
export default class TaskCard extends Vue {
    @Prop({ type: Object, required: true })
    private readonly achievementDetails!: AchievementDetails

    // Daily check-in vuex: engagement.ts
    @Getter private hasUnansweredQuestions!: boolean
    @Action private setEngagementModalOpened

    private readonly checkIcon = faCheck

    private get progressCount() : number {
        return this.achievementDetails.completed
    }

    private get completeCount() : number {
        return this.achievementDetails.requirement
    }

    private get isComplete() : boolean {
        return this.progressCount === this.completeCount
    }

    private get achievementBlurb() : string {
        return !this.isComplete ? this.achievementDetails.rules : 'Completed!'
    }

    private get badgeSvg() : string {
        try {
            return AchievementBadges[this.achievementDetails.type]
        } catch (e) {
            throw new Error("Task achievement badge type undefined.")
        }
    }

    private onTaskClick() {
        if (!this.isComplete) {
            switch (this.achievementDetails.type) {
                case 'checkin':
                    this.checkInTask()
                    break
                case 'suggestion':
                    this.suggestionTask()
                    break
            }
        }
    }

    private checkInTask() {
        // Show the daily check in modal if it has not been answered today
        if (this.hasUnansweredQuestions) {
            this.setEngagementModalOpened(true)
        }
    }

    private suggestionTask() {
        this.$router.push({name: 'suggestionsCreate'})
    }
}
